import React from 'react'
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import styles from './howWeWork.module.css'
import SimpleButton from '../SimpleButton/SimpleButton'

const data = [
    {
        "id": 1,
        "label": "CLIENT MEET "
    },
    {
        "id": 2,
        "label": "Project Initiation"
    },
    {
        "id": 3,
        "label": "Design Phase"
    },
    {
        "id": 4,
        "label": "Development & Testing"
    },
    {
        "id": 5,
        "label": " Deployment & Maintenance"
    }
]

const HowWeWork = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid className={styles.weWork}>
            <Typography variant='h4' sx={{ textAlign: 'center',fontWeight:600 }}>How we works</Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    justifyContent: 'center',
                    gap: { xs: '10px', sm: '16px', md: '24px' },
                    marginTop: '2rem',
                    flexDirection: isMobile ? 'column' : 'row',
                    // This aligns all items to the same height
                    alignItems: 'stretch',
                }}
            >
                {data.map((item) => {
                    return (
                        <Box
                            key={item.id}
                            sx={{
                                // Add a minimum height to ensure consistent button size
                                minHeight: { xs: '60px', sm: '70px', md: '80px' },
                                mb: isMobile ? 1 : 0,
                                width: isMobile ? '100%' : 'auto',
                                maxWidth: isMobile ? '250px' : 'none',
                                // Font size is okay, but you might need to adjust button padding
                                fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <SimpleButton name={item.label} />
                        </Box>
                    )
                })}
            </Box>
        </Grid>
    )
}

export default HowWeWork;